import React from "react";
import Formsy from "formsy-react";

import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import OtpResendRow from "./OtpResendRow";

function OtpCodeForm({
  formBuilder,
  validationErrors,
  clearValidationError,
  translate,
  verifyLoading,
  otpRequestLoading,
  resendDisabled,
  onSubmit,
  onResend,
  resendCooldownSeconds
}) {
  return (
    <Formsy onValidSubmit={onSubmit} validationErrors={validationErrors}>
      <FormBuilderWeb
        {...formBuilder}
        clearValidationError={clearValidationError}
        validationErrors={validationErrors}
      />
      <button
        type={"submit"}
        disabled={verifyLoading || otpRequestLoading}
        className={
          "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
        }
      >
        {verifyLoading ? (
          <i className="fal fa-spinner fa-spin text-black font-semibold mr-2" />
        ) : null}
        {translate("Confirm")}
      </button>
      <OtpResendRow
        translate={translate}
        disabled={resendDisabled}
        onResend={onResend}
        secondsRemaining={resendCooldownSeconds}
      />
    </Formsy>
  );
}

export default OtpCodeForm;
